import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";
//import AccountantHomeView from "../views/Accountant/AccountantHomeView.vue";
import UsersView from "../views/Admin/UsersView.vue";
import SettingsView from "../views/Admin/SettingsView.vue";
import CustomersView from "../views/Admin/CustomersView.vue";
import MetersView from "../views/Admin/MetersView.vue";
import GroupsView from "../views/Admin/GroupsView.vue";
import ReadingsView from "../views/Admin/ReadingsView.vue";
import ActionsView from "../views/Admin/ActionsView.vue";
import TransactionsView from "../views/Admin/TransactionsView.vue";
import MessagesView from "../views/Admin/MessagesView.vue";
import ReportsView from "../views/Admin/ReportsView.vue";
import Report1View from "../views/Admin/Report1View.vue";
import Report2View from "../views/Admin/Report2View.vue";
import Report3View from "../views/Admin/Report3View.vue";
import Report4View from "../views/Admin/Report4View.vue";
import Report5View from "../views/Admin/Report5View.vue";
import Report6View from "../views/Admin/Report6View.vue";
import Report7View from "../views/Admin/Report7View.vue";

import HomeView from "../views/HomeView.vue";
import HomeComponent from "../components/HomeComponent.vue";

import HomeAccView from "../views/Accountant/HomeAccView.vue";
import HomeAccComponent from "../views/Accountant/HomeAccComponent.vue";
import MessagesAccView from "../views/Accountant/MessagesAccView.vue";

const routes = [
  {
    path: "/test_rep",
    name: "test_rep",
    component: LoginView,
  },
  {
    path: "/test",
    name: "test",
    component: () => import("../views/Admin/MetersView1.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/error404",
    name: "error404",
    component: () => import("../views/Errors/Error404View.vue"),
  },
  {
    path: "/",
    name: "Home",
    component: HomeView,
    meta: {
      auth: true,
      roles: ["superadmin", "admin"],
    },
    children: [
      {
        path: "/",
        name: "HomeStatistics",
        component: HomeComponent,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/users",
        name: "usersAdmin",
        component: UsersView,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/settings",
        name: "settingsAdmin",
        component: SettingsView,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/customers",
        name: "customersAdmin",
        component: CustomersView,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/meters",
        name: "metersAdmin",
        component: MetersView,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/groups",
        name: "groupsAdmin",
        component: GroupsView,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/readings",
        name: "readingsAdmin",
        component: ReadingsView,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/actions",
        name: "actionsAdmin",
        component: ActionsView,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/transactions",
        name: "transactionsAdmin",
        component: TransactionsView,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/messages",
        name: "messagesAdmin",
        component: MessagesView,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/reports",
        name: "reportsAdmin",
        component: ReportsView,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/report1",
        name: "report1Admin",
        component: Report1View,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/report2",
        name: "report2Admin",
        component: Report2View,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/report3",
        name: "report3Admin",
        component: Report3View,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/report4",
        name: "report4Admin",
        component: Report4View,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/report5",
        name: "report5Admin",
        component: Report5View,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/report6",
        name: "report6Admin",
        component: Report6View,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
      {
        path: "/report7",
        name: "report7Admin",
        component: Report7View,
        meta: {
          auth: true,
          roles: ["superadmin", "admin"],
        },
      },
    ],
  },
  {
    path: "/acc",
    name: "HomeAcc",
    component: HomeAccView,
    meta: {
      auth: true,
      roles: ["accountant"],
    },
    children: [
      {
        path: "/acc",
        name: "homeAcc",
        component: HomeAccComponent,
        meta: {
          auth: true,
          roles: ["accountant"],
        },
      },
      {
        path: "/acc/actions",
        name: "actionsAccountant",
        component: ActionsView,
        meta: {
          auth: true,
          roles: ["accountant"],
        },
      },
      {
        path: "/acc/messages",
        name: "messagesAcc",
        component: MessagesAccView,
        meta: {
          auth: true,
          roles: ["accountant"],
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const sessionLoggedIn = () =>
    localStorage.getItem("user") != null ? true : false;
  const user = JSON.parse(localStorage.getItem("user"));

  //console.log("user", user);
  //console.log("to roles", to.meta.roles);
  //console.log("to", to);

  if (to.path == "/login" && sessionLoggedIn()) {
    //next(`/${user.data.type}`);
    next("/");
    return;
  }
  if (to.meta.auth && !sessionLoggedIn()) {
    next("/login");
    return;
  }
  if (
    to.path == "/" &&
    sessionLoggedIn() &&
    !to.meta.roles.some((role) => user.roles.includes(role))
  ) {
    next("/acc");
    return;
  }
  if (
    to.meta.roles &&
    !to.meta.roles.some((role) => user.roles.includes(role))
  ) {
    next("/Error404");
    return;
  }
  if (typeof to.name == "undefined") {
    next("/Error404");
    return;
  }
  next();
});

export default router;
